import {
  Component,
  OnInit,
  HostListener,
  ChangeDetectorRef,
  AfterViewInit
} from '@angular/core';
import { PanelDetailsService } from '@shared/services/pre-order/panel-details/panel-details.service';
import { ViewportService } from '@shared/services/viewport/viewport.service';

@Component({
  selector: 'panel-details',
  templateUrl: './panel-details.component.html',
  styleUrls: ['./panel-details.component.scss']
})
export class PanelDetailsComponent implements OnInit, AfterViewInit {
  openPreOrderDetails;
  isMobile;
  preOrderDetails;

  @HostListener('window:resize', ['$event'])
  onResize() {
    setTimeout(() => {
      this._viewportService.checkViewSizes();
    }, 250);
  }

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private _panelDetailsService: PanelDetailsService,
    private _viewportService: ViewportService
  ) {
    this._viewportService.updatingView.subscribe(() => {
      this.isMobile = this._viewportService.isMobile();
      this.openPreOrderDetails = !this.isMobile;
      if (!this.changeDetectorRef['destroyed']) {
        this.changeDetectorRef.detectChanges();
      }
    });
  }

  ngOnInit() {
    this.preOrderDetails = this._panelDetailsService.getPreOrderDetails();
  }

  ngAfterViewInit() {
    this._viewportService.checkViewSizes();
  }
}
